import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const programs = [
  {
    id: 'Financial Inclusion',
    icon: 'ri-bank-line',
    title: 'Financial Inclusion Program',
    tagline: 'Economic Empowerment',
    description:
      'The Financial Inclusion Program provides small, affordable loans to community members — especially women — to start or grow income-generating businesses. Coupled with financial literacy training, this program helps families break the cycle of poverty and build lasting financial security.',
    features: ['mobile money services','Financial literacy training', 'Business mentorship & follow-up', 'saving ','microcredit' ],
    image: 'https://res.cloudinary.com/dtxnjaa8b/image/upload/q_auto/f_auto/v1775057521/financial-inclssion_umoqm2.jpg',
    reached: '100+ Beneficiaries',
  },
  {
    id: 'it-training',
    icon: 'ri-computer-line',
    title: 'ICT Training',
    tagline: 'Digital Skills for the Future',
    description:
      'Our ICT Training program equips youth and adults with practical digital skills needed in today\'s economy. From computer literacy and internet basics to web development and graphic design, graduates are prepared for employment or freelance careers in the digital space.',
    features: ['computer applications , networking ,graphic designing)','Basic computer & internet skills', 'Microsoft Office suite', ],
    image: 'https://res.cloudinary.com/dq9rrrsgx/image/upload/v1774804828/c-training2_tdarpp.jpg',
    reached: '40+ Students Trained',
  },
  {
    id: 'music',
    icon: 'ri-music-2-line',
    title: 'Music Training',
    tagline: 'Nurturing Creative Talents',
    description:
      'Music is a powerful tool for healing, expression, and community building. Our Music Training program provides lessons in vocal performance, choir direction, and musical instruments to youth and community members, fostering both talent and discipline.',
    features: ['Vocal training & choir direction', 'Keyboard & guitar lessons', 'Music theory & composition', 'Public performance opportunities'],
    image: 'https://res.cloudinary.com/dtxnjaa8b/image/upload/q_auto/f_auto/v1775055117/guitr4_n7ko4n.jpg',
    reached: '70+ Youth Enrolled',
  },
  {
    id: 'tailoring',
    icon: 'ri-scissors-line',
    title: 'Tailoring Program',
    tagline: 'Vocational Skills for Livelihood',
    description:
      'The Tailoring Program teaches sewing, garment construction, and fashion design skills to community members, primarily women and youth. Graduates leave with the skills and confidence to start their own tailoring businesses or secure employment in the garment industry.',
    features: ['Sewing machine operation', 'Garment cutting & construction', 'Fashion design principles', 'Business skills for tailors'],
    image: 'https://res.cloudinary.com/darliwxtt/image/upload/v1782151234/tailor_ifujit.jpg',
    reached: '30+ Women Empowered',
  },
  {
    id: 'welding',
    icon: 'ri-hammer-line',
    title: 'Welding and Adjustment',
    tagline: 'Technical Skills for Construction',
    description:
      'Our Welding and Adjustment program provides hands-on training in metalwork, welding techniques, and equipment maintenance. Youth and adults learn practical skills that prepare them for careers in construction, manufacturing, and automotive industries, opening doors to stable employment and entrepreneurship.',
    features: ['Shielded metal arc welding (SMAW)', 'Gas metal arc welding (GMAW)', 'Metal fabrication & fitting', 'Equipment maintenance & safety'],
    image: 'https://res.cloudinary.com/dtxnjaa8b/image/upload/q_auto/f_auto/v1776317372/12_e2pwkb.jpg',
    reached: '25+ Students Trained',
  },

  {
    id: 'food-security',
    icon: 'ri-plant-line',
    title: 'Food Security',
    tagline: 'Healthy Communities, Thriving Families',
    description:
      'Our Food Security program promotes sustainable agriculture, kitchen gardening, and proper nutrition practices. We work with families and farmers to increase food production, reduce malnutrition, and build resilience against climate-related food shortages.',
    features: ['Kitchen & community gardens', 'Sustainable farming techniques', 'Nutrition education workshops', 'Seed distribution support'],
    image: 'https://res.cloudinary.com/dtxnjaa8b/image/upload/q_auto/f_auto/v1775058158/food_rcx8ui.png',
    reached: '200+ Families Supported',
  },
  {
    id: 'health',
    icon: 'ri-heart-pulse-line',
    title: 'Health Counseling',
    tagline: 'Wellness for Whole Communities',
    description:
      'Health is central to community prosperity. Our Health Counseling program provides medical education, mental health awareness, HIV/AIDS counseling, maternal care guidance, and disease prevention campaigns throughout Kajjansi and surrounding communities.',
    features: ['Community health education', 'HIV/AIDS counseling & awareness', 'Maternal & child health support', 'Mental health awareness'],
    image: 'https://res.cloudinary.com/dtxnjaa8b/image/upload/q_auto/f_auto/v1775057673/health---_oku5kk.jpg',
    reached: '80+ Consultations',
  },
  {
    id: 'elderly',
    icon: 'ri-user-heart-line',
    title: 'Elderly & Disability Care',
    tagline: 'Dignity for Every Life',
    description:
      'We believe every person deserves dignity and care regardless of age or ability. Our Elderly & Disability Care program provides home visits, material support, medical assistance, and emotional care to the most vulnerable members of our communities.',
    features: ['Regular home visits & check-ins', 'Food & material support', 'Medical referral assistance', 'Inclusive community events'],
    image: 'https://res.cloudinary.com/dtxnjaa8b/image/upload/q_auto/f_auto/v1775057180/financial_nignxf.jpg',
    reached: '15+ Elders Cared For',
  },
];

export default function ProgramsPage() {
  const [activeProgram, setActiveProgram] = useState<string | null>(null);

  return (
    <div className="min-h-screen">
      <Navbar />

      {/* Hero */}
      <section className="relative h-[50vh] min-h-[360px] flex items-center">
        <div className="absolute inset-0">
          <img
            src="https://res.cloudinary.com/dq9rrrsgx/image/upload/v1774853265/top-prog_drnotb.jpg"
            alt="Our Programs"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-[#003366]/75" />
        </div>
        <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20">
          <nav className="text-sm mb-4">
            <Link to="/" className="text-[#ADD8E6] hover:underline cursor-pointer">Home</Link>
            <span className="text-white/50 mx-2">&rsaquo;</span>
            <span className="text-white">Programs</span>
          </nav>
          <h1 className="text-4xl sm:text-5xl font-bold text-white">Our Programs</h1>
          <p className="text-[#ADD8E6] mt-3 text-lg">Hands to serve , Hearts to care </p>
        </div>
      </section>

      <main>
        {/* Intro strip */}
        <section className="bg-[#ADD8E6] py-14">
          <div className="max-w-4xl mx-auto px-4 text-center">
            <h2 className="text-2xl sm:text-3xl font-bold text-[#003366] mb-3">
              9 Programs Reaching 300+ Lives Annually
            </h2>
            <p className="text-[#003366]/75 text-base">
              From economic empowerment to healthcare, our integrated approach addresses the root causes of poverty and marginalization, creating resilient and self-sufficient communities.
            </p>
          </div>
        </section>

        {/* Programs List */}
        <section className="bg-[#F8F8F8] py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-10">
            {programs.map((prog, index) => (
              <div
                key={prog.id}
                className={`bg-white rounded-2xl overflow-hidden flex flex-col ${
                  index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
                }`}
              >
                {/* Image */}
                <div className="w-full lg:w-2/5 flex-shrink-0 h-64 lg:h-auto">
                  <img
                    src={prog.image}
                    alt={prog.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                {/* Content */}
                <div className="flex-1 p-8 lg:p-10">
                  <span className="inline-block px-3 py-1 bg-[#ADD8E6]/20 text-[#003366] text-xs font-bold rounded-full uppercase tracking-wide mb-3">
                    {prog.tagline}
                  </span>
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 flex items-center justify-center bg-[#003366]/10 rounded-lg flex-shrink-0">
                      <i className={`${prog.icon} text-xl text-[#003366]`} />
                    </div>
                    <h3 className="text-2xl font-bold text-[#003366]">{prog.title}</h3>
                  </div>
                  <p className="text-gray-500 text-sm leading-relaxed mb-5">{prog.description}</p>
                  <ul className="space-y-2 mb-6">
                    {prog.features.map((f) => (
                      <li key={f} className="flex items-start gap-2 text-sm text-gray-600">
                        <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                          <i className="ri-check-line text-[#ADD8E6] font-bold" />
                        </div>
                        {f}
                      </li>
                    ))}
                  </ul>
                  <div className="flex items-center justify-between">
                    <span className="text-[#003366] font-semibold text-sm bg-[#ADD8E6]/20 px-3 py-1.5 rounded-lg">
                      {prog.reached}
                    </span>
                    <Link
                      to="/contact"
                      className="text-sm font-semibold text-[#003366] border border-[#003366] px-4 py-2 rounded-lg hover:bg-[#003366] hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                    >
                      Get Involved
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* CTA */}
        <section className="bg-[#003366] py-16 text-center">
          <div className="max-w-3xl mx-auto px-4">
            <h2 className="text-3xl font-bold text-white mb-4">Support a Program Today</h2>
            <p className="text-white/70 mb-8">
              Your contribution directly funds these transformative programs and changes lives in Uganda.
            </p>
            <div className="flex flex-wrap gap-4 justify-center">
              <Link to="/donate" className="px-8 py-3 bg-[#ADD8E6] text-[#003366] font-bold rounded-lg hover:bg-white transition-colors cursor-pointer whitespace-nowrap">
                Donate Now
              </Link>
              <Link to="/contact" className="px-8 py-3 border-2 border-white text-white font-semibold rounded-lg hover:bg-white hover:text-[#003366] transition-colors cursor-pointer whitespace-nowrap">
                Partner With Us
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
